<template>
  <div class="clear-data">
    <h2>Clear Leaderboard Data?</h2>
    <button @click="clearData">Clear</button>
  </div>
</template>

<script>
export default {
  name: 'clear-data',
  methods: {
    clearData() {
      const api = 'https://6emcgv6qw5.execute-api.us-east-1.amazonaws.com/dev/'
      this.$http.delete(api).then(() => {
          this.$router.push('/takeaway')
      })
    }
  }
}
</script>


<style lang="scss" scoped>
.clear-data {
  color: #4a4a4a;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  button {
    background: #F98B02;
    border: none;
    color: #fff;
    font-size: 18px;
    line-height: 50px;
    padding: 0 35px;
  }
}
</style>
